class HttpRequestsUtility {
  static getMultipartAxiosConfig(onProgress = null) {
    return {
      withCredentials: true,
      headers: {
        'content-type': 'multipart/form-data'
      },
      onUploadProgress: function (progressEvent) {
        let percentCompleted = Math.round(progressEvent.loaded * 100 / progressEvent.total);
        if (onProgress) {
          onProgress(percentCompleted);
        }
      }
    };
  }
}
export default HttpRequestsUtility;